var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "d-flex align-items-center" }, [
    _c(
      "div",
      { staticClass: "flex-fill small" },
      [
        _c("span", [_vm._v(_vm._s(_setup.componentTitle))]),
        _vm._v(" "),
        _c("span", { staticClass: "mx-1 text-secondary" }, [_vm._v(">")]),
        _vm._v(" "),
        _setup.itemTitle
          ? [_vm._v(_vm._s(_setup.itemTitle))]
          : _c("em", { staticClass: "text-muted" }, [_vm._v("untitled")]),
        _vm._v(" "),
        _c("span", { staticClass: "mx-1 text-secondary" }, [_vm._v(">")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_setup.formControlLabel))]),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ms-2" },
      [
        _c(
          _setup.Button,
          {
            staticClass: "btn-light btn-sm",
            nativeOn: {
              click: function ($event) {
                return _setup.goToItem.apply(null, arguments)
              },
            },
          },
          [_c("i", { staticClass: "bi-pencil-square" })]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }